export default __webpack_public_path__ + "static/media/complete_reinforcement_LS.4e40fc2a.png";